import { ApiProperty } from "@nestjs/swagger";

export class PlantPalletRequest{
    @ApiProperty()
    plantId:number;
    @ApiProperty()
    palletId:string;
}